import { getDeviceType } from '~/utils/device'

/** Fires `new_test` when the user starts a new number analysis from the results page. */
export const trackNewTest = () => {
	LuckyWiseAnalytics.click('new_test')
}

/** Fires `jackpot_details` when the user views the jackpot prize breakdown. */
export const trackJackpotDetails = (content) => {
	const params = {
		country: content.country,
		game_name: content.game_name,
		is_random: content.is_random,
		numbers: content.numbers,
		jackpot_prizes: content.jackpot_prizes,
		draw_prizes: content.draw_prizes,
		combination: content.combination,
		winning_combination: content.winning_combination,
	}
	LuckyWiseAnalytics.click('jackpot_details', params)
}

/** Fires `prizes_details` when the user views the full prize-tier breakdown. */
export const trackPrizesDetails = (content) => {
	const params = {
		country: content.country,
		game_name: content.game_name,
		is_random: content.is_random,
		numbers: content.numbers,
		prize_details: content.prize_details,
		draw_prizes: content.draw_prizes,
		combination: content.combination,
		winning_combination: content.winning_combination,
	}
	LuckyWiseAnalytics.click('prizes_details', params)
}

/** Fires `tab_select` when the user switches tabs on the results page (Results / Analysis / Lotteries). */
export const trackTabSelect = (content) => {
	const params = {
		country: content.country,
		game_name: content.game_name,
		is_random: content.is_random,
		numbers: content.numbers,
		hot_numbers: content.hot_numbers,
		cold_numbers: content.cold_numbers,
		prizes_combinations: content.prizes_combinations,
		tab_name: content.tab_name,
	}
	LuckyWiseAnalytics.click('tab_select', params)
}

/*Tab Lotteries Results */
/** Fires `select_lotery` when the user picks a lottery in the Lotteries Results tab. */
export const trackSelectLotery = (content) => {
	const params = {
		game_name: content.game_name,
		is_last_three_months: content.is_last_three_months,
	}
	LuckyWiseAnalytics.click('select_lotery', params)
}

/** Fires `filters_search` when the user applies a date-range filter in the Lotteries Results tab. */
export const trackFilterSearch = (content) => {
	const params = {
		game_name: content.game_name,
		start_date: content.start_date,
		end_date: content.end_date,
	}
	LuckyWiseAnalytics.click('filters_search', params)
}

/* External Links */

/** Fires `purchase_view` when the external purchase link area is displayed. */
export const trackPurchaseView = () => {
	LuckyWiseAnalytics.click('purchase_view')
}

/** Fires `purchase_click_redirect` when the user clicks the external lottery purchase link. */
export const trackPurchaseClickRedirect = (content) => {
	const params = {
		game_name: content.game_name,
		timestamp: content.timestamp,
		origin: content.origin,
	}
	LuckyWiseAnalytics.click('purchase_click_redirect', params)
}

/* How to play component */
/** Fires `lottery_rules_open` when the user expands the "How to play" section. */
export const trackRulesOpen = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		game_name: content.game_name,
		device_type: getDeviceType(),
	}
	LuckyWiseAnalytics.click('lottery_rules_open', params)
}

/** Fires `lottery_rules_play_click` when the user clicks the "Play now" link inside the rules section. */
export const trackRulesPlayClick = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		game_name: content.game_name,
		device_type: getDeviceType(),
		link_url: content.link_url,
	}
	LuckyWiseAnalytics.click('lottery_rules_play_click', params)
}

/** Fires `lottery_rules_official_click` when the user clicks the official lottery website link. */
export const trackRulesOfficialClick = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		game_name: content.game_name,
		device_type: getDeviceType(),
		link_url: content.link_url,
	}
	LuckyWiseAnalytics.click('lottery_rules_official_click', params)
}

/** Fires `alert_saved` when the user successfully saves a draw-result alert. */
export const trackAlertSaved = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		game_name: content.game_name,
		user_name: content.user_name,
		email: content.email,
		timestamp: new Date().toISOString(),
		device_type: getDeviceType(),
	}
	LuckyWiseAnalytics.click('alert_saved', params)
}

/** Fires `performance_analysis_details` when a logged-in user opens the performance analysis section. */
export const trackAnalysisDetail = (content) => {
	const params = {
		user_status: content.user_status,
		lottery_id: content.lottery_id,
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('performance_analysis_details', params)
}

/** Fires `performance_analysis_unlocked` after a user logs in to view a previously locked analysis. */
export const trackAnalysisUnlocked = (content) => {
	const params = {
		user_name: content.name,
		email: content.email,
		lottery_id: content.lottery_id,
		user_id: content.user_id,
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('performance_analysis_unlocked', params)
}

/* Modal Prize Breakdown */

/** Fires `draw_details` when the user opens the prize-breakdown modal for a specific draw. */
export const trackDrawDetails = (content) => {
	const params = {
		user_status: content.user_status,
		lottery_id: content.lottery_id,
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('draw_details', params)
}

/** Fires `draw_details_unlocked` after a user logs in to view a previously locked draw breakdown. */
export const trackDrawDetailsUnlocked = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		timestamp: new Date().toISOString(),
		user_name: content.name,
		email: content.email,
		user_id: content.user_id,
	}
	LuckyWiseAnalytics.click('draw_details_unlocked', params)
}
